// extracted by mini-css-extract-plugin
export default {"container":"AddCapteurComposante_container__JsuHl","btn_stylo":"AddCapteurComposante_btn_stylo__8zIQe"};